<template>
  <div>
    <b-table
      ref="table"
      :fields="fields"
      :items="evidenceSubmissions"
      class="mt-u6"
      show-empty
      empty-text="No submitted Evidence"
      tbody-tr-class="row__submission"
    >
      <template #cell(code)="data">
        <span class="text__submission-id">{{ data.value }}</span>
      </template>

      <template #cell(submitted_no)="data">
        <span class="text__submission-count">{{ data.value }}</span>
      </template>

      <template #cell(submitted_at)="data">
        <span class="text__submitted-date">{{ formatDate(data.value) }}</span>
      </template>

      <template #cell(status)="data">
        <span class="text__submission-status">
          {{ getStatusName(data.item) }}
        </span>
      </template>

      <template #cell(action)="data">
        <router-link :to="getActionLink(data.item)">{{ getAction(data.item) }}</router-link>
      </template>
    </b-table>

    <!-- Pagination -->
    <b-pagination
      ref="pagination"
      v-model="$_currentPage"
      :total-rows="totalItems"
      :per-page="perPage"
      first-number
      last-number
      align="center"
    />
  </div>
</template>

<script>
import moment from 'moment';
import EvidenceSubmission from '@/models/EvidenceSubmission';

export default {
  model: {
    prop: 'vModel',
    event: 'change'
  },
  props: {
    fields: {
      type: Array,
      default: () => [
        {
          key: 'code',
          label: 'SUBMISSION ID',
          thClass: 'bg-white'
        },
        {
          key: 'submitted_no',
          label: 'SUBMITTED NO.',
          thClass: 'bg-white'
        },
        {
          key: 'learning_unit.name',
          label: 'MICRO CREDENTIAL',
          thClass: 'bg-white'
        },
        {
          key: 'submitted_at',
          label: 'SUBMITTED DATE',
          thClass: 'bg-white'
        },
        { key: 'status', label: 'STATUS', thClass: 'bg-white' },
        { key: 'action', label: '', thClass: 'bg-white' }
      ]
    },
    evidenceSubmissions: {
      type: Array,
      default: () => []
    },
    perPage: {
      type: Number,
      default: 1
    },
    totalItems: {
      type: Number,
      default: 0
    },
    vModel: {
      type: Number,
      default: 1,
      required: true
    },
    mode: {
      type: String,
      default: 'assessor'
    },
    userId: {
      type: Number,
      default: null
    }
  },

  computed: {
    $_currentPage: {
      get() {
        return this.vModel;
      },
      set(v) {
        return this.$emit('change', v);
      }
    }
  },

  methods: {
    formatDate(dateTime) {
      return moment(dateTime).format('MMM D, YYYY hh:mm a');
    },

    getStatusName(evidenceSubmission) {
      let statusName = EvidenceSubmission.STATUS[evidenceSubmission.status];

      if (this.mode === 'owner' || this.mode === 'assessor' || this.mode === 'issuer') {
        if (!evidenceSubmission.assessor_reviewed_at) {
          statusName = EvidenceSubmission.STATUS.IN_PROGRESS_BY_ASSESSOR;
        }
        if (evidenceSubmission.assessor_reviewed_at && !evidenceSubmission.issuer_reviewed_at) {
          statusName = EvidenceSubmission.STATUS.IN_PROGRESS_BY_ISSUER;
        }
      }

      return statusName;
    },

    getAction(evidenceSubmission) {
      let action = 'View Feedback';

      if (
        this.mode === 'assessor' &&
        !evidenceSubmission.assessor_reviewed_at &&
        evidenceSubmission.assessor_id === this.userId
      ) {
        action = 'Assess';
      }

      if (
        this.mode === 'issuer' &&
        evidenceSubmission.assessor_reviewed_at &&
        !evidenceSubmission.issuer_reviewed_at
      ) {
        action = 'Assess';
      }

      return action;
    },

    getActionLink(evidenceSubmission) {
      return {
        name:
          this.mode === 'owner'
            ? 'learning-unit/evidence/view'
            : this.mode === 'assessor'
            ? 'learning-unit/evidence/assess'
            : 'learning-unit/evidence/grant',
        params: {
          learningUnitId: evidenceSubmission.learning_unit_id,
          learnerId: evidenceSubmission.user_id,
          evidenceSubmissionId: evidenceSubmission.id
        },
        query: {
          previousPath: this.$route.fullPath
        }
      };
    }
  }
};
</script>

<style></style>
